<template>
  <div class="mt-3 w-100">
    <b-card :class="cardClass" class="h-100 bordered" @click="redirect()">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <chapter-icon :chapter="chapter" />
          <div class="pl-3">
            <p class="h6 mb-0" :class="titleClass">{{ chapter.name }}</p>
          </div>
        </div>
        <b-img
          src="/images/master-dashboard/done.svg"
          v-if="chapter.state === 'completed' && chapter.missionStatus !== 'scheduled'"
          width="18px"
          height="18px"
          class="mt-2"
        />
      </div>

      <div class="d-flex justify-content-end align-items-end">
        <p class="mb-0 text-small text-light-gray">
          <span v-if="chapter.timeToComplete > 0">{{ chapter.timeToComplete }} min</span>
        </p>
        <b-button
          variant="outline-primary"
          class="mr-2"
          v-if="hasSecondaryLink"
          @click.native="trackEventMissionRecap"
          size="sm"
          :to="parseMasterNav(chapter.altRoute)"
        >
          {{ trans("courses.esercizi.see_instructions") }}
        </b-button>
        <b-button
          :variant="chapter.state === 'current' ? 'secondary' : 'primary'"
          v-if="hasLink"
          size="sm"
          :to="parseMasterNav(chapter.route)"
          @click.native="trackEventCompleteMission"
        >
          {{ buttonText }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import navMixin from "../mixins/navMixin";
import ChapterIcon from "../atoms/ChapterIcon";

export default {
  name: "Chapter",
  props: {
    chapter: Object,
  },
  components: { ChapterIcon },
  mixins: [navMixin],
  methods: {
    redirect() {
      if (this.hasSecondaryLink) return;

      if (this.chapter.state !== "locked") {
        this.trackEventCompleteMission();
        this.$router.push(this.parseMasterNav(this.chapter.route));
      } else {
        this.$bvToast.show("locked-chapter-toast");
      }
    },
    trackEventCompleteMission() {
      if (
        this.chapter.missionStatus === "scheduled" ||
        this.chapter.missionStatus === "rescheduled"
      ) {
        trackEvent("completeMissionOnPathway", {});
      }
    },
    trackEventMissionRecap() {
      trackEvent("MissionInstructionRecap", {});
    },
  },
  computed: {
    titleClass: function () {
      let titleClass = "locked";

      if (this.chapter.state !== "locked") {
        titleClass = "";
      }

      if (this.chapter.state === "current") {
        titleClass = "text-white";
      }

      return titleClass;
    },
    cardClass: function () {
      let classes = [];
      switch (this.chapter.state) {
        case "current": {
          classes.push("bg-primary");
          break;
        }
        case "locked": {
          classes.push("bordered shadow-none");
          break;
        }
      }
      if (!this.hasSecondaryLink) {
        classes.push("chapter-card");
      }
      if (this.hasLink) {
        classes.push("shadowed");
      }
      return classes;
    },
    buttonText: function () {
      let text = this.trans("courses.new_dashboard.start_now");
      switch (this.chapter.type) {
        case "certificate":
          text = this.trans("courses.new_dashboard.see_certificate");
          break;
        case "star":
          if (
            this.chapter.missionStatus === "scheduled" ||
            this.chapter.missionStatus === "rescheduled"
          ) {
            text = this.trans("courses.new_dashboard.complete_mission");
          }
          break;
      }
      return text;
    },
    hasLink() {
      if (this.chapter.state === "locked" || this.chapter.state === "completed") {
        return false;
      } else {
        if (this.isMission) {
          return (
            !this.chapter.missionStatus ||
            this.chapter.missionStatus === "not_scheduled" ||
            this.chapter.missionStatus === "scheduled"
          );
        } else {
          return true;
        }
      }
    },
    isMission() {
      return this.chapter.type === "star";
    },
    hasSecondaryLink() {
      if (this.chapter.altRoute !== null) {
        return Object.keys(this.chapter.altRoute).length;
      }
    },
  },
};
</script>
